import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { API_URL_All } from '../../api';
import axios from "axios";
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const UserLevelEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const modalInstance = useRef(null);
  const [isLocked, setIsLocked] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [model, setModel] = useState({});


  useEffect(() => {
    fetchOneRecord(data);
  }, [data]);

  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    try {
      var requestApi = `/api/levels/saveLevelUser`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        general.showFormError('#form_user_level_editor .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.response.data.message ?? error.response.data);
    }

  };

  const fetchOneRecord = async (params) => {
    setModel(params);
    console.log(params);

    setLoaded(true);
    setShow(true);
  };
  return (
    <Modal show={show} onHide={handleModalClose} size="md">
      <div className="modal-dialog11 modal-md11">

        <form id="form_user_level_editor" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{model.id && <span>Cập nhật</span>}{!model.id && <span>Thêm mới</span>}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="row">
                    <div className="col-md-1">
                      <label className="form-label d-none d-md-block">&nbsp;</label>
                      <div className="form-control item-no">
                        <b>#{model.no}</b>
                      </div>
                    </div>
                    <div className="col-6 col-md-11">
                      <label className="form-label">Mã khách hàng</label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-key="list_customers">
                          {model.id && (
                            <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." data-required="Phải nhập mục này." disabled={!loaded} value={model.customerCode ?? ''} onChange={(e) => setModel({ ...model, customerCode: e.target.value })} />

                          )}
                          {!model.id && (
                            <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." disabled={!loaded} value={model.customerCode ?? ''} onChange={(e) => setModel({ ...model, customerCode: e.target.value })} />

                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
            <div className="modal-footer justify-content-between">
              <div>

              </div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default UserLevelEditor;
